module.exports = __webpack_public_path__ + "GameArt&Design-cac43682.webp";